<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="indigo">view_list</v-icon>
      知识产权基本信息
      <v-spacer/>

      <v-btn
        flat round color="primary" dark
        :disabled="!funcIds.includes('u_inteApp')"
        @click.native.stop="
             () => {
                  editDbid = item.dbid;
                  edit = true;
                }">
        <v-icon>edit</v-icon>
        修改基本信息
      </v-btn>

    </v-card-title>
    <v-divider color="indigo"/>
    <v-card-text class="pt-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <div class="x-text-field">
              <label>知识产权名称</label>
              <div>{{ item.name }}</div>
            </div>
          </v-flex>
          <v-flex xs3>
            <div class="x-text-field">
              <label>知识产权类型</label>
              <div>{{ !item.type?"": item.type.name }}</div>
            </div>
          </v-flex>
          <v-flex xs3>
            <div class="x-text-field">
              <label>知识产权属地</label>
              <div>{{ affiliationMap[item.affiliation] }}</div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="x-text-field">
              <label>归属部门</label>
              <div>{{ !item.department?"" : item.department.name}}</div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="x-text-field">
              <label>代理机构</label>
              <div>{{!item.agency? "" : item.agency.name}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <x-orgs-view
              label="归属单位列表"
              v-model="item.orgs"
              hint="申请人列表"
            />
          </v-flex>
          <v-flex xs12>
            <x-apps-view
              label="参与人列表"
              v-model="item.apps"
              hint="参与人列表"
            />
          </v-flex>
          <v-flex xs12>
            <div class="x-text-field">
              <label>专利来源</label>
              <div>{{item.source}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div v-if="item.attachments &&  item.attachments.length > 0">
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol class="section-list">
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/inte/file/${a.dbid}`" target="_blank" class="x-ellipsis">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'
  import XAppsView from '../appsView'
  import XOrgsView from '../orgsView'
  import XEdit from './edit'

  export default {
    components: {XAppsView,XOrgsView,XEdit},

    props: {
      inteApp: Object
    },

    data: () => ({
      fileUri: '/api/inte/file',
      item: {},
      affiliationMap:{
        gn: "国内",
        gw: "国外"
      },
      edit: false,
      editDbid: null,
    }),

    watch: {
      inteApp(v) {
        if (v) this.item = v;
      }
    },
    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      onEditOk(v) {
        if (v) {
          this.item = window.xutil.clone(v);
          this.$emit("ok", this.item);
        }
      }
    }
  }
</script>
